export const MESSAGES_CHAT_URL = `${process.env.PUBLIC_URL || ""}/messages-chat.json`;

export const STARTER_QUESTIONS = [
  "Generate a follow-up email for a potential lead.",
  "Draft a quick update to share with the exec team.",
  "Find inconsistencies in our latest performance data.",
  "Review this document and extract action items.",
];

export const CHAT_INPUT_ADD_MENU_ITEMS = [
  { icon: "attach_file", text: "Upload File", value: "upload", showTag: true, tagColor: "success" },
  { icon: "hardDrive2", text: "Add from AIMS Drive", value: "drive", showTag: true, tagColor: "success" },
];

export const DOCUMENT_SEARCH_PROPS = {
  searchPlaceholder: "Search documents...",
  maxHeight: "500px",
  height: "500px",
};
